export default __webpack_public_path__ + "static/media/e2dataio.8b7a1d5b.svg";